var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSetUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 247,
    viewBox: "0 0 240 247",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23495_34402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.8184 198.051L25.459 65.3666L58.7326 52.291L111.092 184.975",
    stroke: "#FACC15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6085 34.3467L35.97 31.0588C42.8369 28.3585 50.6167 31.7354 53.3216 38.5904L58.7273 52.2899L25.4696 65.3677L20.0639 51.6683C17.3589 44.8133 20.7417 37.047 27.6085 34.3467Z",
    stroke: "#FACC15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8183 198.051L102.139 210.992L111.092 184.975L100.117 184.056L94.0844 191.894L84.7943 190.313L77.8183 198.051Z",
    stroke: "#FACC15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7128 57.7075L80.5593 143.484",
    stroke: "#FACC15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.593 100.59C188.311 113.497 190.67 128.748 187.244 144.044L94.4664 123.253M79.436 84.7779C94.4327 69.8521 116.529 62.6751 138.738 67.6429C148.342 69.796 156.947 73.99 164.204 79.6755M109.519 162.379L114.799 163.556L148.803 171.182L193.4 181.174L201.409 182.968C207.194 184.269 212.946 180.635 214.238 174.86L219.54 151.277C223.371 134.232 222.393 117.22 217.496 101.644C207.487 69.7511 181.043 43.8692 145.86 35.9745C117.315 29.5825 88.8946 36.367 67.0567 52.2797M51.9925 149.494L32.7271 145.177C26.9306 143.887 23.3022 138.157 24.5941 132.37L29.8963 108.798C30.604 105.647 31.4577 102.575 32.4575 99.5692",
    stroke: "#68B1E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.556 167.078L193.389 181.185",
    stroke: "#68B1E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.971 157.086L148.792 171.193",
    stroke: "#68B1E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.944 149.494L114.777 163.601",
    stroke: "#68B1E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.352 148.339L219.529 151.288",
    stroke: "#68B1E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.6 105.67L217.496 101.655",
    stroke: "#68B1E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.717 69.6053L190.861 59.6809",
    stroke: "#68B1E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.826 49.7903L146.781 36.6362",
    stroke: "#68B1E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.094 51.5395L97.0613 38.677",
    stroke: "#68B1E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.934 27.8107C116.08 26.779 116.147 25.7361 116.147 24.6708C116.147 11.6625 105.588 1.12134 92.5679 1.12134C79.5483 1.12134 68.9776 11.6625 68.9776 24.6708C68.9776 30.5694 71.1569 35.9745 74.7628 40.1013",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.407 221.668C167.933 221.668 174.033 215.578 174.033 208.065C174.033 200.552 167.933 194.462 160.407 194.462C152.881 194.462 146.781 200.552 146.781 208.065C146.781 215.578 152.881 221.668 160.407 221.668Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4103 174.243V201.561",
    stroke: "#68B1E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0928 187.902H28.728",
    stroke: "#68B1E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.281 78.4646V108.417",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.289 93.4353H156.284",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.759 48.4446C199.735 31.1526 214.957 31.6236 214.957 31.6236",
    stroke: "#FACC15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.858 58.5933C209.07 50.4519 216.956 54.3095 216.956 54.3095",
    stroke: "#FACC15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23495_34402"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 205,
    height: 247,
    fill: "white",
    transform: "translate(18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetUp);
export default __webpack_public_path__ + "static/media/SetUp.8399a0f946ca9af81f5060c0c42ab4f6.svg";
export { ForwardRef as ReactComponent };